<template>
  <div class="Description">
    <!-- <div class="Description_img">
      <img :src="`http://www.opendbar.cn/images/${Description.image}`" alt="" />
      <p><i class="iconfont icon-fangda1"></i>查看大图</p>
    </div> -->

    <div class="Description_text">{{ Description.introduction }}</div>
  </div>
</template>

<script>
export default {
  props: ["Description"],
};
</script>

<style lang="scss">
.Description {
//   min-height: 200px;
padding-bottom: 20px;
  border-bottom: 4px solid #fbfbfb;
 overflow : hidden;
  #imgtext {
  width: 180px;
}
.Description_img {
    margin-left: 30px;
  width: 160px;
  height: 120px;
  float: right;
    img{
        border-radius: 3px;
        width: 100%;
        height: 90px;
        border: 1px solid rgb(253, 249, 249)
    }
    p{
        cursor: pointer;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        transition: .2s;
        &:hover{
            opacity: .7;
            transition: .2s;
        }
        i{
            margin-right: 4px;
            font-size: 14px;
        
        }
    }
}
.Description_text {
    text-indent: 28px;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
}
}

</style>